import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="nosotros" className="py-32 bg-bodyon-surface relative overflow-hidden" data-id="element-15">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-16">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-0" data-id="element-17">
          {/* Left: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-5/12 lg:pr-16 relative" data-id="element-18">
            {/* Vertical Accent Line */}
            <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-bodyon-teal hidden lg:block -ml-8" data-id="element-19"></div>

            <h2 className="inline-flex items-center px-5 py-2.5 rounded-full border border-gray-300 text-gray-500 font-medium tracking-[0.2em] uppercase text-xs mb-6" data-id="element-20">
              {t('about.title')}
            </h2>

            <div className="mb-12 relative" data-id="element-21">
              <span className="absolute -top-10 -left-8 text-[120px] font-heading font-black text-bodyon-teal/10 leading-none" data-id="element-22">
                "
              </span>
              <h3 className="font-heading font-bold text-4xl md:text-5xl text-bodyon-teal-dark leading-tight italic relative z-10" data-id="element-23">
                {t('about.heading')}
              </h3>
            </div>

            <div className="space-y-8 text-xl text-gray-600 font-light leading-relaxed" data-id="element-24">
              <p data-id="element-25">{t('about.desc1')}</p>
              <p data-id="element-26">{t('about.desc2')}</p>
            </div>
          </motion.div>

          {/* Right: Breakout Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-7/12 relative lg:-mr-[10vw]" data-id="element-27">
            <div className="aspect-[4/3] lg:aspect-[16/10] rounded-[40px] overflow-hidden relative shadow-2xl" data-id="element-28">
              <div className="absolute inset-0 bg-bodyon-teal/10 mix-blend-multiply z-10" data-id="element-29" />
              <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80" alt="Medical Professional" className="w-full h-full object-cover filter grayscale hover:grayscale-0 transition-all duration-1000 scale-105 hover:scale-100" data-id="element-30" />
            </div>

            {/* Dramatic decorative blurs */}
            <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-bodyon-teal/30 rounded-full blur-[80px] -z-10" data-id="element-31" />
            <div className="absolute -top-20 right-20 w-80 h-80 bg-bodyon-mint/30 rounded-full blur-[100px] -z-10" data-id="element-32" />
          </motion.div>
        </div>
      </div>
    </section>;
}